module.exports = __webpack_public_path__ + "img/deng.7e97e002.png";